<template>
    <emc-chart-apex-base :series="series" type="line" :options="chartOptions" :loading.sync="loading">

        <template v-slot:actions>
            <emc-chart-refresh-status :label="statusLabel" :failed="hasFailed" :error-code="errorCode" />
            <v-spacer></v-spacer>
            <emc-button-icon btn-small :disabled="isBusy" icon="mdi-refresh-circle" :text="updated_at || `Atualizar`" color="success" @click.prevent.stop="start()" />
        </template>
    </emc-chart-apex-base>
</template>

<script>

import { getCurrentInstance } from 'vue'
import { mapActions } from 'vuex'
import { useChartRefresh } from '@/composables/useChartRefresh'

export default {
    name: 'EmcChartEvolutionOfWorkload',
    setup() {
        const { proxy } = getCurrentInstance()

        return useChartRefresh({
            refreshAction: 'chart/ActionEvolutionOfWorkloadRefresh',
            onFinished: () => proxy.getData()
        })
    },
    data () {
        return {
            // Só o carregamento inicial: durante a recarga o gráfico continua
            // visível com o indicador ao lado, em vez de virar esqueleto.
            loading: true,
            name: 'EvolutionOfWorkload',
            updated_at: null,
            series: [],
            chartOptions: {
                xaxis: {
                    categories: []
                },
                yaxis: {
                    title: {
                        text: 'Carga horária'
                    }
                },
                colors: [],
                title: {}
            }
        }
    },
    methods: {
        ...mapActions('chart', ['ActionChartEvolutionOfWorkload']),
        async getData(){
            await this.ActionChartEvolutionOfWorkload()
                .then((r) => {
                    this.series = r.data.series
                    this.chartOptions.xaxis.categories = r.data.categories
                    this.chartOptions.title.text = r.data.title
                    this.chartOptions.colors = r.data.colors
                    this.updated_at = r.data.updated_at

                    // Recarga já em andamento (normalmente a carga noturna):
                    // o gráfico mostra o andamento sem o usuário ter clicado.
                    this.adopt(r.data.refresh)
                })
                .finally(() => {
                    this.loading = false
                })

        }
    },
    created(){
        this.getData();
    }
}
</script>